import { render, staticRenderFns } from "./AddressHeader.vue?vue&type=template&id=77238968&scoped=true"
import script from "./AddressHeader.vue?vue&type=script&lang=js"
export * from "./AddressHeader.vue?vue&type=script&lang=js"
import style0 from "./AddressHeader.vue?vue&type=style&index=0&id=77238968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77238968",
  null
  
)

export default component.exports